import tinycolor from 'tinycolor2';
import {Theme} from '../types/Theme';

export default class ColorHelpers {

  public static getOutlineColor(color: string, theme: Exclude<Theme, 'auto' | 'unthemed'>): string {
    switch (theme) {
      case 'light':
        return tinycolor(color).darken(25).toRgbString();
      case 'dark':
        return tinycolor(color).lighten(25).toRgbString();
      default:
        return '#FF00FF';
    }
  }

  public static getInteractionCueColor(color: string, theme: Exclude<Theme, 'auto' | 'unthemed'>): string {
    switch (theme) {
      case 'light':
        return tinycolor(color).lighten(10).toRgbString();
      case 'dark':
        return tinycolor(color).darken(10).toRgbString();
      default:
        return '#FF00FF';
    }
  }

  public static lighten(color: string, percent: number): string {
    return tinycolor(color).lighten(10).toRgbString();
  }

  public static pickBestContrastColor(backgroundColor: string, options: string[]) {
    return tinycolor.mostReadable(backgroundColor, options).toRgbString();
  }
}
